module.exports = __webpack_public_path__ + "images/163_160.jpg";